import { NotificationActions, NotificationsTypes } from './notification.store';
import { errors } from '../resources/messages';

export const CollectionStoreDefinition = {
  state: {
    coins: [],
    isPending: false,
    hasBeenInitialized: false,
    hasError: false,
    change: 0,
  },
  mutations: {
    addCoin(state, coin) {
      state.coins.push(coin);
    },
    removeCoin(state, id) {
      const index = state.coins.findIndex(coin => coin.docId === id);
      if (index > -1) {
        state.coins.splice(index, 1);
      }
    },
    updateCoin(state, coin) {
      const { docId } = coin;
      const index = state.coins.findIndex(coin => coin.docId === docId);
      if (index > -1) {
        state.coins[index] = coin;
      }
    },
    collectionHasChanged(state) {
      state.change++;
    },
    collectionHasBeenInitialized(state) {
      state.hasBeenInitialized = true;
    },
    collectionStartQuery(state) {
      state.isPending = true;
    },
    collectionEndQuery(state) {
      state.isPending = false;
    },
    collectionCleanError(state) {
      state.hasError = false;
    },
    collectionAddError(state) {
      state.hasError = true;
    },
    getCoins(state, coins) {
      state.coins = coins;
    },
    collectionClean(state) {
      state.coins = [];
    },
  },
  getters: {
    getCoinByDocId: (state) => (docId) => {
      return state.coins.find(coin => coin.docId === docId);
    },
    getCoinById: (state) => (id) => {
      return state.coins.find(coin => coin.id === id);
    },
  },
  actions: {
    startUpdateCoin({ commit }) {
      commit(CollectionMutations.collectionCleanError);
      commit(CollectionMutations.collectionStartQuery);
    },
    endSuccessUpdateCoin({ commit }, coin) {
      commit(CollectionMutations.updateCoin, coin);
      commit(CollectionMutations.collectionHasChanged);
      commit(CollectionMutations.collectionEndQuery);
    },
    endFailUpdateCoin({ commit, dispatch }) {
      commit(CollectionMutations.collectionAddError);
      commit(CollectionMutations.collectionEndQuery);
      dispatch(NotificationActions.createNotification, {
        type: NotificationsTypes.error,
        message: errors.collection.update
      });
    },
    startGetCoins({ commit }) {
      commit(CollectionMutations.collectionCleanError);
      commit(CollectionMutations.collectionStartQuery);
    },
    endSuccessGetCoins({ commit }, coins) {
      commit(CollectionMutations.collectionHasBeenInitialized);
      commit(CollectionMutations.getCoins, coins);
      commit(CollectionMutations.collectionHasChanged);
      commit(CollectionMutations.collectionEndQuery);
    },
    endFailGetCoins({ commit, dispatch }) {
      commit(CollectionMutations.collectionAddError);
      commit(CollectionMutations.collectionEndQuery);
      dispatch(NotificationActions.createNotification, {
        type: NotificationsTypes.error,
        message: errors.collection.get
      });
    },
    startAddCoin({ commit }) {
      commit(CollectionMutations.collectionCleanError);
      commit(CollectionMutations.collectionStartQuery);
    },
    endSuccessAddCoin({ commit }, coin) {
      commit(CollectionMutations.addCoin, coin);
      commit(CollectionMutations.collectionHasChanged);
      commit(CollectionMutations.collectionEndQuery);
    },
    endFailAddCoin({ commit, dispatch }) {
      commit(CollectionMutations.collectionAddError);
      commit(CollectionMutations.collectionEndQuery);
      dispatch(NotificationActions.createNotification, {
        type: NotificationsTypes.error,
        message: errors.collection.create
      });
    },
    startRemoveCoin({ commit }) {
      commit(CollectionMutations.collectionCleanError);
      commit(CollectionMutations.collectionStartQuery);
    },
    endSuccessRemoveCoin({ commit }, id) {
      commit(CollectionMutations.removeCoin, id);
      commit(CollectionMutations.collectionHasChanged);
      commit(CollectionMutations.collectionEndQuery);
    },
    endSuccessRemoveAllCoins({ commit }) {
      commit(CollectionMutations.collectionClean);
      commit(CollectionMutations.collectionHasChanged);
      commit(CollectionMutations.collectionEndQuery);
    },
    endFailRemoveCoin({ commit, dispatch }) {
      commit(CollectionMutations.collectionAddError);
      commit(CollectionMutations.collectionEndQuery);
      dispatch(NotificationActions.createNotification, {
        type: NotificationsTypes.error,
        message: errors.collection.remove
      });
    },
    cleanCollection({ commit }) {
      commit(CollectionMutations.collectionClean);
    }
  }
};

export const CollectionMutations = {
  addCoin: 'addCoin',
  getCoins: 'getCoins',
  updateCoin: 'updateCoin',
  removeCoin: 'removeCoin',
  collectionStartQuery: 'collectionStartQuery',
  collectionEndQuery: 'collectionEndQuery',
  collectionCleanError: 'collectionCleanError',
  collectionAddError: 'collectionAddError',
  collectionHasBeenInitialized: 'collectionHasBeenInitialized',
  collectionHasChanged: 'collectionHasChanged',
  collectionClean: 'collectionClean',
};

export const CollectionActions = {
  startAddCoin: 'startAddCoin',
  endSuccessAddCoin: 'endSuccessAddCoin',
  endFailAddCoin: 'endFailAddCoin',
  startRemoveCoin: 'startRemoveCoin',
  endSuccessRemoveCoin: 'endSuccessRemoveCoin',
  endFailRemoveCoin: 'endFailRemoveCoin',
  startUpdateCoin: 'startUpdateCoin',
  endSuccessUpdateCoin: 'endSuccessUpdateCoin',
  endFailUpdateCoin: 'endFailUpdateCoin',
  startGetCoins: 'startGetCoins',
  endSuccessGetCoins: 'endSuccessGetCoins',
  endFailGetCoins: 'endFailGetCoins',
  cleanCollection: 'cleanCollection',
  endSuccessRemoveAllCoins: 'endSuccessRemoveAllCoins',
};
